import z from 'zod/v4';

export const ConnectionApplicationDataSchemaForCommissioning = z.object({
  devicesToInstall: z.array(
    z.object({
      deviceSysRef: z.string(),
      generatorType: z.string().nullish(),
    })
  ),
});
